import script from "./CreativeUploadAlerts.vue?vue&type=script&setup=true&lang=js"
export * from "./CreativeUploadAlerts.vue?vue&type=script&setup=true&lang=js"

import "./CreativeUploadAlerts.vue?vue&type=style&index=0&id=f1ef4c46&lang=css"

const __exports__ = script;

export default __exports__